<template>
  <div>
    <div v-if="currentYearLoaded && previousYearLoaded">
      <div v-if="showSum">
        {{(actualHours-requiredHours) | hour}}
      </div>
      <div v-else>
        {{actualHours | hour}}/{{requiredHours-(this.illnessHours) | hour}}
      </div>
      <div v-if="showCarryOverFromPreviousYear">
         (Letztes Jahr: {{ (actualHoursPreviousYear - requiredHoursPreviousYear) | hour }})
      </div>
    </div>
    <div v-else>
      ...
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import moment from "moment";
import { off } from "process";

  export default {
    name: "userRequiredHours",
    props: ['user', 'from', 'to', 'showSum', 'carryOver', 'index', 'showCarryOverFromPreviousYear'],
    data: function () {
      // Can't reuse shared previous year object because it's stateful
      var startOfPreviousYear = moment().subtract(1, "year").startOf("year");
      var endOfPreviousYear = moment().subtract(1, "year").endOf("year");

      return {
        requiredHours: 0,
        actualHours: 0,
        currentYearLoaded: false,
        previousYearLoaded: false,
        startOfPreviousYear: startOfPreviousYear,
        endOfPreviousYear: endOfPreviousYear,
        requiredHoursPreviousYear: 0,
        actualHoursPreviousYear: 0,
        illnessHours: 0
      }
    },
    created: function () {
      this.$emit('illness', this.illnessHours);
    },
    methods: {
    },
    mounted() {
      //Load users
      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "hours/GetRequiredWorkingHoursInRange?userId=" + this.user.id + "&from=" + this.from.format('yyyy-MM-DD') + "&to=" + this.to.format('yyyy-MM-DD') }).then(result => {
        this.requiredHours = result.data.workHoursRequired;
        this.actualHours = result.data.workHours;
        this.currentYearLoaded = true;
        this.$emit('carryOverCalculated', this.index, this.actualHours - this.requiredHours);
      }, error => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });

      axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "hours/GetRequiredWorkingHoursInRange?userId=" + this.user.id + "&from=" + this.startOfPreviousYear.format('yyyy-MM-DD') + "&to=" + this.endOfPreviousYear.format('yyyy-MM-DD') }).then(result => {
        this.requiredHoursPreviousYear = result.data.workHoursRequired;
        this.actualHoursPreviousYear = result.data.workHours;
        this.previousYearLoaded = true;
      }, error => {
        console.error(error);
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      });

      // get previous year hours, pass them to carryover
      if(this.index == 1){

        var fromStart=moment('2017-01-01').startOf("year").format("yyyy-MM-DD");
        var toNow= moment(this.from).startOf("year").format("yyyy-MM-DD");
        console.log("fromStart: ----------- "+fromStart);
        console.log("toNow: ----------- "+toNow);

        // get previous year hours
        axios({ method: "GET", url: process.env.VUE_APP_API_PATH+"hours/GetRequiredWorkingHoursInRange?userId="+this.user.id+"&from="+fromStart+"&to="+toNow }).then(result => {
          console.log("method called previous year hours");
          var totalHoursDifferencePrevYear=result.data.workHours-result.data.workHoursRequired;
            this.$emit('carryOverCalculated', 1, totalHoursDifferencePrevYear, true);

        }, error => {
          console.error(error);
          if(error.response.status==401) {
            this.$router.push("/");
          }
        });
      }


    }
  };
</script>
